/** The company map in the console and in the shared link (27/10/2026). Twin of `it.ts`. */
export default {
  pagina: {
    titolo: 'Company map',
    titolo_condivisa: 'The companies working with YumaOS',
    descrizione: 'Where the companies using YumaOS are, with their accounts and the people working on it.',
    elenco: 'List',
    mappa: 'Map',
    vista: 'How to view the companies',
    condividi: 'Share the map',
    aggiorna: 'Refresh the data',
    caricamento: 'Drawing the map…',
    errore: 'The map did not load: {{motivo}}',
    riprova: 'Try again',
    aggiornata: 'Data as of {{quando}}',
    fonte_confini: 'Borders: ISTAT, processed by openpolis (CC BY 4.0)',
    confini_assenti: 'The outline of Italy did not load: the companies are in place, but without the borders.',
    valida_fino: 'Link valid until {{data}}',
  },
  livelli: {
    free: 'Free',
    base: 'Base',
    pro: 'Pro',
    business: 'Business',
  },
  stati: {
    attiva: 'Active',
    pagamenti_in_ritardo: 'Payments overdue',
    sospesa: 'Suspended',
    bloccata: 'Blocked',
    cancellata: 'Cancelled',
  },
  stato_singolare: {
    attiva: 'Active',
    pagamenti_in_ritardo: 'Payments overdue',
    sospesa: 'Suspended',
    bloccata: 'Access blocked',
    cancellata: 'Cancelled',
  },
  filtri: {
    adesso: 'At work now',
    adesso_gruppo: 'Right now',
    stato: 'Which companies',
    livello: 'Plans',
    tutte: 'All',
    nessuna: 'No company matches these filters.',
    mostra_tutte: 'Show all companies',
  },
  riepilogo: {
    come_sedi: 'The dashed circle: another site of the same company.',
    come_archi: 'The arcs start from a partner\'s company and reach the companies it brought to YumaOS.',
    sedi_one: '{{count}} site',
    sedi_other: '{{count}} sites',
    adesso_one: 'person at work right now',
    adesso_other: 'people at work right now',
    adesso_breve: 'now',
    come_polso: 'The pulsing green ring: someone is working there right now (did something in the system in the last {{minuti}} minutes, or has the app in front). An idle open page does not count.',
    numero_adesso: '{{adesso}} now',
    aziende_one: 'company',
    aziende_other: 'companies',
    account_one: 'account',
    account_other: 'accounts',
    persone_one: 'person at work in the last {{giorni}} days',
    persone_other: 'people at work in the last {{giorni}} days',
    account_per_livello: 'Accounts by plan',
    livello_conto: '{{livello}} {{numero}}',
    come_si_legge: 'How to read it',
    come_alone: 'The halo is as large as the company’s accounts.',
    come_nucleo: 'The logo sits in the middle; the colour around it is as large as the people who used the system in the last {{giorni}} days.',
    come_colore: 'The colour is the plan: Free is the outline alone.',
    elenco: 'The companies',
    al_lavoro_breve: 'at work',
    al_lavoro: '{{attive}} at work',
    senza_posizione: 'Not on the map',
    motivi: {
      senza_indirizzo: 'the head office address is missing',
      indirizzo_non_trovato: 'the head office address cannot be found',
      fuori_dall_italia: 'the head office is outside Italy',
      posizione_non_calcolata: 'position not calculated, try again later',
    },
  },
  scheda: {
    portata_da: 'Brought to YumaOS by',
    ha_portato: 'Brought to YumaOS',
    fornitore: 'Materials supplier',
    rifornisce: 'Supplies',
    rifornisce_quante_one: '{{count}} company',
    rifornisce_quante_other: '{{count}} companies',
    fuori_dai_filtri: 'not shown with the current filters',
    chi_lavora_adesso: 'Who is working right now',
    canale: {
      gestionale: 'System',
      app: 'App',
    },
    canale_aiuto: {
      gestionale: 'Using the management system, in a computer or tablet browser',
      app: 'Using an Android app (YumaCALL or YumaWORK)',
    },
    sedi: 'Sites',
    sede_principale: 'main',
    sede_legale: 'registered office: the company has not entered any operating sites',
    al_centro_del_comune: 'at the centre of the town: the street was not found',
    vai_alla_sede: 'Show {{sede}} on the map',
    sedi_fuori_one: '{{count}} operating site is not on the map: {{motivo}}',
    sedi_fuori_other: '{{count}} operating sites are not on the map: {{motivo}}',
    adesso: 'At work now',
    adesso_valore_one: '{{count}} person',
    adesso_valore_other: '{{count}} people',
    pagina_aperta: 'Page open, but idle',
    chi_ha_la_pagina_aperta: 'Who has the system open but is not using it',
    ultima_azione: 'last action {{quando}}',
    ultima_azione_non_misurata: 'last action not measured yet (their page needs a reload)',
    adesso_nessuno: 'nobody right now',
    torna: 'Back to the summary',
    logo: '{{nome}} logo',
    iscritta: 'Signed up on',
    account: 'Accounts',
    account_totale_one: '{{count}} account',
    account_totale_other: '{{count}} accounts',
    nessun_account: 'No accounts',
    persone_attive: 'At work in the last {{giorni}} days',
    attive_su: '{{attive}} of {{totale}}',
    ultimo_uso: 'Last used',
    ultimo_uso_oggi: 'today at {{ora}}',
    ultimo_uso_ieri: 'yesterday at {{ora}}',
    ultimo_uso_settimana: '{{giorno}} at {{ora}}',
    ultimo_uso_prima: '{{data}}',
    ultimo_uso_mai: 'nobody has used it yet',
    posti: 'Seats purchased',
    posti_valore: '{{usati}} used of {{acquistati}}',
    posti_senza_limite: 'unlimited',
    abbonamenti: {
      esente: 'Exempt',
      in_prova: 'On trial',
      pagante: 'Paying',
      insoluto: 'Unpaid',
      cancellato: 'Cancelled',
      gratuito: 'Free',
    },
    apri: 'Open the company page',
  },
  mappa: {
    sede: '{{azienda}}, {{sede}} site',
    luoghi_due: '{{a}} and {{b}}',
    luoghi_altri_one: '{{luogo}} and one more town',
    luoghi_altri_other: '{{luogo}} and {{count}} more towns',
    descrizione: 'Map of Italy with the companies',
    avvicina: 'Zoom in',
    allontana: 'Zoom out',
    tutta_italia: 'Back to all of Italy',
    gruppo: '{{count}} companies close together: tap to zoom in',
    segno_adesso: '{{nome}}: {{account}} accounts, {{adesso}} at work now',
    segno: '{{nome}}: {{account}} accounts, {{attive}} at work',
  },
  pannello: {
    stesso_punto_one: '{{count}} company at this spot',
    stesso_punto_other: '{{count}} companies at the same spot',
    apri: 'Open the summary',
    riduci: 'Collapse the summary',
  },
  condividi: {
    titolo: 'Share the map',
    spiegazione: 'Whoever receives the link sees the map of active companies: name, logo, town, plan, accounts, people at work and sign-up date. They do not see payments, purchased seats or inactive companies, and they do not get into the management system.',
    destinatario: 'Who it is for',
    destinatario_aiuto: 'It helps you recognise the link in the list. Whoever opens it does not see it.',
    destinatario_esempio: 'Mario Rossi, bank',
    durata: 'Valid for',
    giorni_one: '{{count}} day',
    giorni_other: '{{count}} days',
    crea: 'Create the link',
    creando: 'Creating the link…',
    pronto: 'The link for {{destinatario}} is ready: valid until {{data}}.',
    copia: 'Copy the link',
    copiato: 'Link copied',
    copia_non_riuscita: 'Copying failed: select the link and copy it by hand.',
    altro: 'Create another link',
    attivi: 'Links created',
    nessun_link: 'No links created so far.',
    scade_il: 'valid until {{data}}',
    scaduto_il: 'expired on {{data}}',
    aperto_one: 'opened {{count}} time, last {{quando}}',
    aperto_other: 'opened {{count}} times, last {{quando}}',
    mai_aperto: 'not opened yet',
    ritira: 'Revoke',
    ritira_titolo: 'Revoke the link for {{destinatario}}?',
    ritira_testo: 'Whoever has the link will no longer see the map. A revoked link cannot be reactivated: if it is needed again, create a new one.',
    ritira_conferma: 'Revoke the link',
    ritirato: 'Link for {{destinatario}} revoked',
    annulla: 'Cancel',
    chiudi: 'Close',
    errore: 'The link was not saved: {{motivo}}',
  },
  condivisa: {
    non_attivo_titolo: 'This link is no longer active',
    non_attivo_testo: 'Ask whoever sent it to you for a new link.',
  },
} as const;
